import React from "react";
import { cn } from "@/lib/utils";

const toneFor = (confidence) => {
  if (confidence === null || confidence === undefined) return { dot: "var(--ink-tertiary)" };
  if (confidence >= 0.75) return { dot: "var(--state-ok)" };
  if (confidence >= 0.4) return { dot: "var(--state-warn)" };
  return { dot: "var(--state-critical)" };
};

export const IntakeConfidenceField = ({ label, value, confidence, fragment, testId, onHover, onLeave }) => {
  const tone = toneFor(confidence);
  return (
    <div
      data-testid={testId}
      onMouseEnter={() => fragment && onHover?.(fragment)}
      onMouseLeave={() => onLeave?.()}
      className={cn(
        "flex items-center justify-between gap-3 rounded-[6px] px-2 py-1.5 transition-colors",
        fragment ? "cursor-help hover:bg-surface-sunken" : ""
      )}
    >
      <span className="text-[11.5px] text-ink-tertiary">{label}</span>
      <span className="flex items-center gap-1.5 text-right text-[12.5px] font-medium text-ink">
        {value || "—"}
        <span className="h-[6px] w-[6px] shrink-0 rounded-full" style={{ backgroundColor: tone.dot }} />
      </span>
    </div>
  );
};

export const HighlightedText = ({ text, fragment }) => {
  if (!fragment || !text) return <>{text}</>;
  const idx = text.toLowerCase().indexOf(fragment.toLowerCase());
  if (idx === -1) return <>{text}</>;
  return (
    <>
      {text.slice(0, idx)}
      <mark className="rounded-[2px] bg-state-warn-soft px-0.5 text-state-warn">
        {text.slice(idx, idx + fragment.length)}
      </mark>
      {text.slice(idx + fragment.length)}
    </>
  );
};
